<template>
  <div class="mask" @click="hide" ref="cardRef">
    <div class="card_box" ref="cardBoxRef" @click.stop>
      <div class="close_btn">
        <div class="card_title">{{templeData.name}}</div>
        <i class="el-icon-close" @click="hide"></i>
      </div>
      <div class="card_info roll">
        <!-- <div class="item_carousel card">
          <ImgList :imgUrl="templeData.picture"> </ImgList>
        </div> -->
        <div class="menu_item">
          <div id="edit_map"></div>
        </div>
        <div class="menu_item">
          <el-form ref="editFormRef" :rules="rules" :model="editData" label-width="7rem" size="small ">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 妈祖庙名称 -->
                <el-form-item :label='$t("templeinfo.name")' prop="name">
                  <el-input v-model="editData.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 妈祖庙父庙 -->
                <el-form-item :label='$t("templeinfo.father")' prop="father_id">
                  <el-select v-model="editData.fatherId" filterable :placeholder='$t("from.t1")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in fatherTemple" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!-- 修建年代 -->
                <el-form-item :label='$t("templeinfo.years")' prop="years">
                  <el-input @input="getDynasty(editData.years)" v-model="editData.years" maxlength="4" :disabled="yearChecked"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-checkbox v-model="yearChecked" @change="yearClickChange">{{$t("templeinfo.unknown")}}</el-checkbox>
                  <div class="dynasty_box">
                    <!--   朝代 -->
                    {{$t("templeinfo.dynasty")}}： {{editData.dynasty}}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 经度 -->
                <el-form-item :label='$t("templeinfo.longitude")' prop="longitude">
                  <el-input v-model="editData.longitude"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 纬度 -->
                <el-form-item :label='$t("templeinfo.latitude")' prop="latitude">
                  <el-input v-model="editData.latitude"></el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 大洲 -->
                <el-form-item :label='$t("templeinfo.continent")' prop="continent">
                  <!-- <el-input v-model="editData.continent"></el-input> -->
                  <el-select v-model="editData.continent" :placeholder='$t("from.t2")'>
                    <el-option v-for="(item, i) in op_continent" :key="i" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>

              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 国家 -->
                <el-form-item :label='$t("templeinfo.country")' prop="country">
                  <!-- <el-input v-model="editData.country"></el-input> -->
                  <el-select v-model="editData.country" filterable :placeholder='$t("from.t3")' style="width: 100%;">
                    <el-option v-for="(item, i) in op_country" :key="i" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12"> <!-- 省份 -->
                <el-form-item :label='$t("templeinfo.province")' prop="province">
                  <el-input v-model="editData.province"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 城市 -->
                <el-form-item :label='$t("templeinfo.city")'>
                  <el-input v-model="editData.city"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 县、区 -->
                <el-form-item :label='$t("templeinfo.county")'>
                  <el-input v-model="editData.county"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <!-- 地址 -->
                <el-form-item :label='$t("templeinfo.address")'>
                  <el-input v-model="editData.address"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <!-- 描述 -->
                <el-form-item :label='$t("templeinfo.description")'>
                  <el-input type="textarea" rows="5" maxlength="5000" show-word-limit v-model="editData.description"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label='$t("from.t26")'>
                  <EditImg ref="editImgRef" :picture="templeData.picture" @editlist="editlist"> </EditImg>
                </el-form-item>
              </el-col>

            </el-row>
            <!-- 人文历史 -->
            <div class="edit_title"> {{$t("templeinfo.history")}}：</div>
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <!--  例祭-->
                <el-form-item :label='$t("templeinfo.sacrifice")'>
                  <el-input type="textarea" rows="4" maxlength="1000" show-word-limit v-model="editData.sacrifice"></el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <!-- 是否迁移 -->
                <el-form-item :label='$t("templeinfo.migration")'>
                  <!-- <el-input v-model="editData.migration"></el-input> -->
                  <el-select v-model="editData.migration" :placeholder='$t("from.t7")'>
                    <!-- 是 -->
                    <el-option :label='$t("common.yes")' value="1">
                    </el-option>
                    <!-- 否 -->
                    <el-option :label='$t("common.no")' value="0">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <!-- 迁徙原址 -->
                <el-form-item :label='$t("templeinfo.migrationRoot")'>
                  <el-input v-model="editData.migrationRoot" maxlength="50"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <!-- 迁徙原因类型 -->
                <el-form-item :label='$t("templeinfo.migrationReasontype")'>
                  <!-- <el-input v-model="editData.migrationType"></el-input> -->
                  <el-select v-model="editData.migrationType" :placeholder='$t("from.t8")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in migrationType" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <!-- 迁移原因 -->
                <el-form-item :label='$t("templeinfo.migrationReason")'>
                  <el-input type="textarea" :rows="4" maxlength="1000" v-model="editData.migrationReason"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <!-- 是否修缮过 -->
                <el-form-item :label='$t("templeinfo.repair")'>
                  <!-- <el-input v-model="editData.repair"></el-input> -->
                  <el-select v-model="editData.repair" :placeholder='$t("from.t7")'>
                    <!-- 是 -->
                    <el-option :label='$t("common.yes")' value="1">
                    </el-option>
                    <!-- 否 -->
                    <el-option :label='$t("common.no")' value="0">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <!-- 保存状况 -->
                <el-form-item :label='$t("templeinfo.saveStatr")'>
                  <!-- <el-input v-model="editData.saveStatr"></el-input> --> <!-- 请选择保存状况 -->
                  <el-select v-model="editData.saveStatr" :placeholder='$t("from.t9")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in saveStatr" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <!-- 修缮记录 -->
                <el-form-item :label='$t("templeinfo.repairRecord")'>
                  <el-input type="textarea" :rows="4" maxlength="1000" v-model="editData.repairRecord"></el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <!-- 损坏原因类型 -->
                <el-form-item :label='$t("templeinfo.damageType")'>
                  <!-- <el-input v-model="editData.damageType"></el-input> -->
                  <el-select v-model="editData.damageType" :placeholder='$t("from.t10")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in damageType" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <!-- 损坏原因 -->
                <el-form-item :label='$t("templeinfo.damageReason")'>
                  <el-input type="textarea" :rows="4" maxlength="500" v-model="editData.damageReason"></el-input>
                </el-form-item>
              </el-col>
            </el-row> <!-- 建筑风格 -->
            <div class="edit_title">{{$t("templeinfo.style")}}：</div>
            <el-row :gutter="20">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 妈祖庙长度 -->
                <el-form-item :label='$t("templeinfo.buildLength") +"(m)"' prop="buildLength">
                  <el-input v-model="editData.buildLength"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 妈祖庙宽度 -->
                <el-form-item :label='$t("templeinfo.buildWidth") +"(m)"' prop="buildWidth">
                  <el-input v-model="editData.buildWidth"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 妈祖庙面积m² -->
                <el-form-item :label='$t("templeinfo.buildArea") +"(m²)"' prop="buildArea">
                  <el-input v-model="editData.buildArea"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 妈祖庙层数 -->
                <el-form-item :label='$t("templeinfo.buildFloor")'>
                  <el-input v-model="editData.buildFloor"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 妈祖庙数量 -->
                <el-form-item :label='$t("templeinfo.buildNum")'>
                  <el-input v-model="editData.buildNum"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 庙区长度 -->
                <el-form-item :label='$t("templeinfo.districtLength") +"(m)"'>
                  <el-input v-model="editData.districtLength"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 庙区宽度 -->
                <el-form-item :label='$t("templeinfo.districtWidth") +"(m)"'>
                  <el-input v-model="editData.districtWidth"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 庙区面积 -->
                <el-form-item :label='$t("templeinfo.districtArea") +"(m²)"'>
                  <el-input v-model="editData.districtArea"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 建筑风格 -->
                <el-form-item :label='$t("templeinfo.buildStyle")'>
                  <el-input maxlength="50" v-model="editData.buildStyle"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 建筑结构类型 -->
                <el-form-item :label='$t("templeinfo.buildType")'>
                  <!-- <el-input v-model="editData.buildType"></el-input> -->
                  <el-select v-model="editData.buildType" :placeholder='$t("from.t11")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in buildType" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 墙体材料 -->
                <el-form-item :label='$t("templeinfo.wallType")'>
                  <!-- <el-input v-model="editData.wallType"></el-input> -->
                  <el-select v-model="editData.wallType" :placeholder='$t("from.t12")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in wallType" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 建筑布局 -->
                <el-form-item :label='$t("templeinfo.bulidLayout")'>
                  <!-- <el-input v-model="editData.bulidLayout"></el-input> -->
                  <el-select v-model="editData.bulidLayout" :placeholder='$t("from.t13")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in bulidLayout" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 屋瓦 -->
                <el-form-item :label='$t("templeinfo.watts")'>
                  <!-- <el-input v-model="editData.watts"></el-input> -->
                  <el-select v-model="editData.watts" :placeholder='$t("from.t14")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in watts" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 屋顶 -->
                <el-form-item :label='$t("templeinfo.roof")'>
                  <!-- <el-input v-model="editData.roof"></el-input> -->
                  <el-select v-model="editData.roof" :placeholder='$t("from.t15")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in roof" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 雀替纹样 -->
                <el-form-item :label='$t("templeinfo.texture")'>
                  <!-- <el-input v-model="editData.texture"></el-input> -->
                  <el-select v-model="editData.texture" :placeholder='$t("from.t16")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in texture" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 窗户样式 -->
                <el-form-item :label='$t("templeinfo.window")'>
                  <!-- <el-input v-model="editData.window"></el-input> -->
                  <el-select v-model="editData.window" :placeholder='$t("from.t17")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in window" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 柱子形式 -->
                <el-form-item :label='$t("templeinfo.pillarsStyle")'>
                  <!-- <el-input v-model="editData.pillarsStyle"></el-input> -->
                  <!-- 请选择柱子形式 -->
                  <el-select v-model="editData.pillarsStyle" :placeholder='$t("from.t18")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in pillarsStyle" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 柱子材料 -->
                <el-form-item :label='$t("templeinfo.pillarsMaterial")'>
                  <!-- <el-input v-model="editData.pillarsMaterial"></el-input> -->
                  <el-select v-model="editData.pillarsMaterial" :placeholder='$t("from.t19")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in pillarsMaterial" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 柱础 -->
                <el-form-item :label='$t("templeinfo.pillarsBasis")'>
                  <!-- <el-input v-model="editData.pillarsBasis"></el-input> -->
                  <el-select v-model="editData.pillarsBasis" :placeholder='$t("from.t20")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in pillarsBasis" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 柱面装饰 -->
                <el-form-item :label='$t("templeinfo.pillarsDecoration")'>
                  <!-- <el-input v-model="editData.pillarsDecoration"></el-input> -->
                  <el-select v-model="editData.pillarsDecoration" :placeholder='$t("from.t21")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in pillarsDecoration" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 铺地 -->
                <el-form-item :label='$t("templeinfo.floor")'>
                  <!-- <el-input v-model="editData.floor"></el-input> -->
                  <el-select v-model="editData.floor" :placeholder='$t("from.t22")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in floor" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 屋脊 -->
                <el-form-item :label='$t("templeinfo.ridge")'>
                  <!-- <el-input v-model="editData.ridge"></el-input> -->
                  <el-select v-model="editData.ridge" :placeholder='$t("from.t23")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in ridge" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 屋脊装饰 -->
                <el-form-item :label='$t("templeinfo.ridgeDecoration")'>
                  <!-- <el-input v-model="editData.ridgeDecoration"></el-input> -->
                  <el-select v-model="editData.ridgeDecoration" :placeholder='$t("from.t24")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in ridgeDecoration" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 建筑支撑结构 -->
                <el-form-item :label='$t("templeinfo.support")'>
                  <!-- <el-input v-model="editData.support"></el-input> -->
                  <el-select v-model="editData.support" :placeholder='$t("from.t25")'>
                    <el-option :label="item.label" :value="item.value" v-for="(item,i) in support" :key="i">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="btn_group">
        <el-button size="mini" @click="hide">{{$t("common.cancel")}}</el-button>
        <el-button size="mini" @click="editFun()" type="primary">{{$t("common.sure")}}</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import myJson from "@/assets/json/json.js";
import ImgList from "./ImgList.vue";
import EditImg from "./EditImg.vue";

import { mapGetters } from "vuex";
export default {
  name: "EditInfo",
  components: {
    ImgList,
    EditImg,
  },
  props: {
    info: Object,
  },
  computed: {
    ...mapGetters([
      "bulidLayout",
      "watts",
      "roof",
      "texture",
      "pillarsStyle",
      "pillarsMaterial",
      "pillarsBasis",
      "pillarsDecoration",
      "ridgeDecoration",
      "support",
      "window",
      "buildType",
      "migrationType",
      "saveStatr",
      "damageType",
      "floor",
      "ridge",
      "wallType",
      "fatherTemple",
    ]),
  },
  data() {
    var checkXY = (rule, value, callback) => {
      // var reg = /^(([^0][0-9]+|0)\.([0-9]{1,6})$)|^([^0][0-9]+|0)$/;
      var reg = /^(\-|\+)?\d+(\.\d+)?$/;
      if (!reg.test(value)) {
        // 坐标格式不正确
        callback(new Error(this.$t("from.e1")));
      } else {
        callback();
      }
    };
    var checkNum = (rule, value, callback) => {
      var reg = /^(([^0][0-9]+|0)\.([0-9]{1,6})$)|^([^0][0-9]+|0)$/;

      if (value === "") {
        callback();
      } else if (!reg.test(value)) {
        // 格式不正确
        callback(new Error(this.$t("from.e2")));
      } else {
        callback();
      }
    };
    var checkYears = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      setTimeout(() => {
        var d = new Date();
        if (!Number.isInteger(value)) {
          // 请输入数字
          callback(new Error(this.$t("from.e3")));
        } else {
          if (value < 987) {
            // 修建年代必须在987年以后
            callback(new Error(this.$t("from.e4")));
          } else if (value > d.getFullYear()) {
            // 修建年代必须在  年之前
            this.$t("from.e5") + d.getFullYear() + this.$t("from.e6");
          } else {
            callback();
          }
        }
      }, 500);
    };
    return {
      // isShow: false,
      moreInfo: {}, //详细信息
      templeData: {},
      editData: {},
      editMap: null,
      editMark: null,
      op_continent: myJson.continentList(), //大洲
      op_country: myJson.countryList(), //国家
      uploadFlag: false, //是否确认上传
      allImg: [], //所有图片
      addImg: [], //已添加的图片
      delImg: [], //待删除的图片
      // 图片编辑相关

      yearChecked: false,
      rules: {
        name: [
          // 请输入妈祖庙名称
          { required: true, message: this.$t("from.e8"), trigger: "blur" },
          {
            min: 2,
            max: 16,
            // 长度在 2 到 16 个字符
            message: this.$t("from.e9"),
            trigger: "blur",
          },
        ],
        years: [{ validator: checkYears, trigger: "blur" }],
        longitude: [
          {
            required: true,
            // 请拖动地图标记选择经度
            message: this.$t("from.e10"),
            trigger: "blur",
          },
          { validator: checkXY, trigger: "blur" },
        ],
        latitude: [
          {
            required: true,
            // 请拖动地图标记选择纬度
            message: this.$t("from.e11"),
            trigger: "blur",
          },
          { validator: checkXY, trigger: "blur" },
        ],
        fatherId: [
          {
            required: true,
            // 请选择父庙，未知请选择湄洲岛妈祖祖庙
            message: this.$t("from.e12"),
            trigger: "blur",
          },
        ],
        continent: [
          {
            required: true,
            // 请选择大洲
            message: this.$t("from.e13"),
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            // 请选择国家
            message: this.$t("from.e14"),
            trigger: "blur",
          },
        ],
        // province: [
        //   {
        //     required: true,
        //     message: "请输入省份",
        //     trigger: "blur",
        //   },
        // ],
        // city: [
        //   {
        //     required: true,
        //     message: "请输入城市",
        //     trigger: "blur",
        //   },
        // ],
        // buildLength: [{ validator: checkNum, trigger: "blur" }],
        // buildWidth: [{ validator: checkNum, trigger: "blur" }],
        // buildArea: [{ validator: checkNum, trigger: "blur" }],
      },
    };
  },
  created() {},

  watch: {
    info(newVal, oldVal) {
      this.templeData = newVal;
      // 将maker标记的位置设置为获取到的妈祖庙的坐标
      this.editMark.setLatLng([newVal.latitude, newVal.longitude]);
      // 调整地图显示，将maker标记置为地图中心
      this.editMap.flyTo([newVal.latitude, newVal.longitude], 8);
      this.getMoreInfo();
    },
  },
  mounted() {
    this.initmap(); //加载地图
  },
  methods: {
    // 详细信息 地图
    initmap() {
      var that = this;
      let map = this.$leaflet.map("edit_map", {
        minZoom: 1,
        maxZoom: 18,
        // 范围限制
        maxBounds: [
          //south west
          [90, -270],
          //north east
          [-90, 360],
        ],
        center: [25.090924, 119.147698],
        zoom: 3,
        zoomControl: true,
        attributionControl: false,
      });
      this.$leaflet.tileLayer(this.common.mapurl).addTo(map);
      map._onResize();
      // maker样式
      var makerIcon = this.$leaflet.icon({
        iconUrl: "./static/img/maker.png", //maker图片
        shadowUrl: "./static/img/mshadow.png", //maker阴影
        iconSize: [24, 30], // 图标的大小
        shadowSize: [26, 20], // 阴影的大小
        iconAnchor: [12, 30], // 图标的点，该点将与标记的位置相对应
        shadowAnchor: [4, 18], // the same for the shadow
        popupAnchor: [2, -30], //弹出窗口相对于图标打开的点
      });
      // 添加一个可移动的maker，用来表示妈祖庙位置
      var marker = this.$leaflet
        .marker([25.090574, 119.146299], { icon: makerIcon, draggable: true })
        .addTo(map);
      that.editMap = map;
      that.editMark = marker;
      // maker弹窗
      // 拖动标记以修改坐标
      marker.bindPopup(that.$t("from.e16")).openPopup();
      // maker移动时，获取其坐标并填入表单
      marker.on("dragend", onDragEnd);
      //标记移动事件
      function onDragEnd() {
        that.editData.longitude = marker._latlng.lng.toFixed(4);
        that.editData.latitude = marker._latlng.lat.toFixed(4);
      }
    },

    // 更多信息滚动条置顶
    scroll() {
      // 滚动条置顶
      // document.querySelector(".el-dialog__wrapper").scrollTop = 0;
    },

    show() {
      this.editData = JSON.parse(JSON.stringify(this.moreInfo));
      // this.isShow = true;
      this.$refs.cardRef.style.marginTop = "0";
      this.$refs.cardBoxRef.style.marginTop = "0";
    },
    hide() {
      // this.isShow = false;
      if (this.uploadFlag) {
        this.uploadFlag = false;
      } else {
        //没有确认修改, 需删除已上传的图片
        this.$refs.editImgRef.restore();
        if (this.addImg.length > 0) {
          this.deleteImg(this.addImg);
        }
      }
      this.editData = {};
      this.$refs.cardRef.style.marginTop = "100vh";
      this.$refs.cardBoxRef.style.marginTop = "100vh";
    },
    getMoreInfo() {
      let pardata = { templeID: this.templeData.id };
      this.$Loading.show();
      this.http.From("temple/getTempleInfo", pardata).then((res) => {
        this.$Loading.hide();
        if (res.code == "0") {
          this.moreInfo = res.data;
          this.editData = JSON.parse(JSON.stringify(res.data));
          // console.log("getMoreInfo");
          // console.log(this.editData);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //图片编辑相关
    editlist(allImg, addImg, delImg) {
      this.allImg = allImg;
      this.addImg = addImg;
      this.delImg = delImg;
    },

    editFun() {
      this.$Loading.show();
      //  如果有删除图片的情况
      if (this.delImg.length > 0) {
        this.deleteImg(this.delImg);
      }
      this.editData.picture = this.allImg.toString().replaceAll(",", "#");
      this.editData.state = "2";
      this.http.post("temple/editTempleInfo", this.editData).then((res) => {
        this.$Loading.hide();
        if (res.code == "0") {
          this.uploadFlag = true;
          this.$emit("reback", true);
          this.hide();
          this.$message({
            message: this.$t("from.t27"),
            type: "success",
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    deleteImg(item) {
      // 删除图片
      this.$Loading.show();
      let pardata = {
        fileList: item.toString(),
      };
      this.http.From("/file/deleteFile", pardata).then((res) => {
        this.$Loading.hide();
        if (res.code == "0") {
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 年代不詳
    yearClickChange() {
      if (this.yearChecked == true) {
        this.editData.years = "";
        this.editData.dynasty = this.$t("from.e7"); // 暂不详
      }
    },
    // 计算朝代
    getDynasty(year) {
      this.editData.dynasty = this.common.getDynasty(year);
      // console.log(this.editData.dynasty);
    },
  },
};
</script>
<style scoped lang="scss">
@import "../assets/css/_common.scss";

.mask {
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 100vh;
  .card_box {
    margin-top: 100vh;
    width: 50%;
    max-width: 60rem;
    height: 100%;
    background: rgb(255, 255, 255);
    position: absolute;
    top: $head-height;
    left: 50%;
    margin-left: -25%;
    height: calc(100vh - $head-height - 4rem);
    border-radius: $r-mid;
    transition: all 0.5s;
    .dynasty_box {
      // width: 8rem;
      height: 2rem;
      display: inline-block;
      margin-left: $m-mid;
      color: #333;
    }
    .close_btn {
      color: $c-main;
      font-size: $f-hug;
      margin: $m-lit;
      padding-right: $m-mid;
      text-align: right;
      .card_title {
        float: left;
        color: $c-main;
        margin-left: $m-mid;
      }
      i {
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          transform: rotate(180deg);
          color: $c-second;
        }
      }
    }
    .btn_group {
      width: 90%;
      margin: $m-mid auto;
      text-align: right;
    }
    .card_info {
      width: 90%;
      height: calc(100vh - $head-height - 12rem);
      margin: 0 auto;
      overflow: hidden;
      overflow-y: auto;
      .item_carousel {
        height: 12rem;
        margin: 0 auto;
        margin-bottom: $m-lit;
        overflow: hidden;
      }
      #edit_map {
        height: 16rem;
        border-radius: $r-mid;
        box-sizing: border-box;
        box-shadow: $shadow;
        margin: 0 auto;
        margin-bottom: $m-lit;
      }
      .menu_item {
        margin: 0 auto;
        padding: $m-lit;
        .left_btn {
          font-size: $f-lit;
          display: flex;
          justify-content: space-around;
          align-items: center;
          span {
            opacity: 0.8;
            cursor: pointer;
            &:hover {
              color: $c-main;
            }
          }
        }

        .edit_title {
          color: $c-main;
          border-bottom: $b-border-dashed;
          margin: $m-mid;
          padding: $m-lit;
          font-size: $f-mid;
        }
        .table_box {
          border-radius: $r-min;
          table {
            width: 100%;
            color: $c-text-main;
            border-collapse: collapse;
            tr,
            th,
            td {
              border: 1px solid $c-main-light;
              // line-height: 1.5rem;
              font-size: $f-lit;
              padding: 0;
              margin: 0;
            }
            th {
              width: 6rem;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 451px) and (max-width: 650px) {
  .mask {
    .card_box {
      width: 80%;
      left: 50%;
      margin-left: -40%;
    }
  }
}
</style>
